import React, {useContext} from 'react';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import RadioGroup from '@mui/material/RadioGroup';
import Typography from '@mui/material/Typography';
import BidmiiRadio from '../../../common/StyledComponents/BidmiiRadio';
import {NewProjectContext} from '../utils/NewProjectContext';
import BidmiiTextField from '../../../common/StyledComponents/BidmiiTextField';

interface IProps {
  value?: $TSFixMe;
  setValue?: $TSFixMe;
  label: string;
  options: any[];
  otherValue?: string | null;
  setOtherValue?: any;
}

// Todo - maybe we should change the name of prop state, setState to something more explicit such as value, setValue
const MultipleChoice = ({
  value,
  setValue,
  label,
  options,
  otherValue,
  setOtherValue,
}: IProps) => {
  const {homeDepot} = useContext(NewProjectContext);

  const handleRadioChange = (event: $TSFixMe) => {
    setOtherValue && setOtherValue(null);
    setValue(event.target.value);
  };

  return (
    <FormControl
      variant="standard"
      component="fieldset"
      style={{width: '100%'}}>
      <Typography variant="h6" fontSize={22} mb={3} lineHeight={1.4}>
        {label}
      </Typography>
      <RadioGroup name={label} value={value} onChange={handleRadioChange}>
        {options.map((option: $TSFixMe, i: $TSFixMe) => {
          return (
            <BidmiiRadio
              key={i}
              state={value}
              value={option.value}
              label={
                option.image ? (
                  <Grid container direction="column" alignItems="center">
                    <img
                      alt={'Before'}
                      style={{width: 60, height: 60}}
                      src={option.label}
                    />
                    <Typography variant="caption">{option.value}</Typography>
                  </Grid>
                ) : (
                  option.label
                )
              }
              style={{marginBottom: 0}}
              color={homeDepot ? '#CB4814' : undefined}
            />
          );
        })}
        {otherValue !== undefined && (
          <BidmiiRadio
            state={value}
            value="Other"
            label="Other - Please describe"
            style={{marginBottom: 0}}
            color={homeDepot ? '#CB4814' : undefined}
          />
        )}
        {/* </Grid> */}
      </RadioGroup>

      {value === 'Other' && (
        <BidmiiTextField
          value={otherValue}
          onChange={(e) => setOtherValue(e.target.value)}
          placeholder="Other"
          homeDepot={homeDepot}
        />
      )}
    </FormControl>
  );
};

export default MultipleChoice;
